import { useState } from "react";
import { Check } from "lucide-react";
import { GROEPS, PHASES, DIFFICULTIES } from "../../lib/constants";
import { Button } from "../ui/button";

export function LevelPicker({ initial, onSave, onCancel, title = "Kies je niveau", subtitle, forced = false }) {
  const valid = typeof initial === "string" && /^[BME][3-8]$/.test(initial);
  const [groep, setGroep] = useState(valid ? Number(initial[1]) : 5);
  const [phase, setPhase] = useState(valid ? initial[0] : "M");
  const code = `${phase}${groep}`;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-5" style={{ background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)" }} data-testid="level-picker">
      <div className="w-full max-w-md rounded-3xl border-2 p-7" style={{ background: "var(--t-surface)", borderColor: "var(--t-border)", color: "var(--t-text)" }}>
        <h2 className="font-heading text-2xl font-black themed-heading">{title}</h2>
        {subtitle && <p className="mt-1 font-semibold" style={{ color: "var(--t-muted)" }}>{subtitle}</p>}

        <p className="mt-5 text-sm font-bold uppercase tracking-wider" style={{ color: "var(--t-muted)" }}>Groep</p>
        <div className="grid grid-cols-6 gap-2 mt-2">
          {GROEPS.map((g) => (
            <button key={g} data-testid={`groep-${g}`} onClick={() => setGroep(g)}
              className="py-3 rounded-xl font-heading font-extrabold transition-all active:scale-95 border-2"
              style={groep === g ? { background: "var(--t-primary)", color: "var(--t-on-primary)", borderColor: "var(--t-primary)" } : { background: "var(--t-surface2)", color: "var(--t-text)", borderColor: "var(--t-border)" }}>{g}</button>
          ))}
        </div>

        <p className="mt-5 text-sm font-bold uppercase tracking-wider" style={{ color: "var(--t-muted)" }}>Wanneer in het schooljaar?</p>
        <div className="grid grid-cols-3 gap-2 mt-2">
          {PHASES.map((p) => (
            <button key={p.id} data-testid={`phase-${p.id}`} onClick={() => setPhase(p.id)}
              className="py-3 rounded-xl font-bold transition-all active:scale-95 border-2"
              style={phase === p.id ? { background: "var(--t-accent)", color: "var(--t-on-accent)", borderColor: "var(--t-accent)" } : { background: "var(--t-surface2)", color: "var(--t-text)", borderColor: "var(--t-border)" }}>{p.label}</button>
          ))}
        </div>

        <div className="mt-6 p-3 rounded-2xl text-center font-bold" style={{ background: "var(--t-surface2)" }} data-testid="level-preview">
          Gekozen: <span style={{ color: "var(--t-accent)" }}>{DIFFICULTIES[code]}</span>
        </div>

        <div className="flex gap-3 mt-6">
          <Button onClick={() => onSave(code)} data-testid="level-save-btn" className="flex-1 h-12 rounded-xl font-bold border-0" style={{ background: "var(--t-primary)", color: "var(--t-on-primary)" }}><Check className="w-5 h-5 mr-1.5" /> Opslaan</Button>
          {!forced && <Button onClick={onCancel} data-testid="level-cancel-btn" className="h-12 rounded-xl font-bold bg-transparent border-2" style={{ borderColor: "var(--t-border)", color: "var(--t-text)" }}>Annuleren</Button>}
        </div>
      </div>
    </div>
  );
}
